import type { ChargePolicyType, Values } from '../AppsTwitch.types'

export const getChargePolicy = (
  type: Values['shippingChargeType'],
  max: Values['shippingCharge'],
): ChargePolicyType => {
  return { shipping: type === 'MAX_CREATOR' ? { type, max: Number(max) } : { type } }
}
